export enum Type {
  AJAX_FETCH_CREDIT_BOOSTER_RATES         = 'AJAX_FETCH_CREDIT_BOOSTER_RATES',
  AJAX_FETCH_CREDIT_BOOSTER_RATES_FAIL    = 'AJAX_FETCH_CREDIT_BOOSTER_RATES_FAIL',
  AJAX_FETCH_CREDIT_BOOSTER_RATES_SUCCESS = 'AJAX_FETCH_CREDIT_BOOSTER_RATES_SUCCESS',
}
